export const regionlist  =[
    {
        "id": 110000,
        "tagId": 110000,
        "tagName": "北京",
        "parentId": 0,
        "tagType": 1,
        "tagDescription": null,
        "deleted": null,
        "isValid": null,
        "orderSeq": null,
        "childBaseTag": null
    },
    {
        "id": 120000,
        "tagId": 120000,
        "tagName": "天津",
        "parentId": 0,
        "tagType": 1,
        "tagDescription": null,
        "deleted": null,
        "isValid": null,
        "orderSeq": null,
        "childBaseTag": null
    },
    {
        "id": 130000,
        "tagId": 130000,
        "tagName": "河北省",
        "parentId": 0,
        "tagType": 1,
        "tagDescription": null,
        "deleted": null,
        "isValid": null,
        "orderSeq": null,
        "childBaseTag": [
            {
                "id": 130100,
                "tagId": 130100,
                "tagName": "石家庄市",
                "parentId": 130000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 130200,
                "tagId": 130200,
                "tagName": "唐山市",
                "parentId": 130000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 130300,
                "tagId": 130300,
                "tagName": "秦皇岛市",
                "parentId": 130000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 130400,
                "tagId": 130400,
                "tagName": "邯郸市",
                "parentId": 130000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 130500,
                "tagId": 130500,
                "tagName": "邢台市",
                "parentId": 130000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 130600,
                "tagId": 130600,
                "tagName": "保定市",
                "parentId": 130000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 130700,
                "tagId": 130700,
                "tagName": "张家口市",
                "parentId": 130000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 130800,
                "tagId": 130800,
                "tagName": "承德市",
                "parentId": 130000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 130900,
                "tagId": 130900,
                "tagName": "沧州市",
                "parentId": 130000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 131000,
                "tagId": 131000,
                "tagName": "廊坊市",
                "parentId": 130000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 131100,
                "tagId": 131100,
                "tagName": "衡水市",
                "parentId": 130000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            }
        ]
    },
    {
        "id": 140000,
        "tagId": 140000,
        "tagName": "山西省",
        "parentId": 0,
        "tagType": 1,
        "tagDescription": null,
        "deleted": null,
        "isValid": null,
        "orderSeq": null,
        "childBaseTag": [
            {
                "id": 140100,
                "tagId": 140100,
                "tagName": "太原市",
                "parentId": 140000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 140200,
                "tagId": 140200,
                "tagName": "大同市",
                "parentId": 140000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 140300,
                "tagId": 140300,
                "tagName": "阳泉市",
                "parentId": 140000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 140400,
                "tagId": 140400,
                "tagName": "长治市",
                "parentId": 140000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 140500,
                "tagId": 140500,
                "tagName": "晋城市",
                "parentId": 140000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 140600,
                "tagId": 140600,
                "tagName": "朔州市",
                "parentId": 140000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 140700,
                "tagId": 140700,
                "tagName": "晋中市",
                "parentId": 140000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 140800,
                "tagId": 140800,
                "tagName": "运城市",
                "parentId": 140000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 140900,
                "tagId": 140900,
                "tagName": "忻州市",
                "parentId": 140000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 141000,
                "tagId": 141000,
                "tagName": "临汾市",
                "parentId": 140000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 141100,
                "tagId": 141100,
                "tagName": "吕梁市",
                "parentId": 140000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            }
        ]
    },
    {
        "id": 150000,
        "tagId": 150000,
        "tagName": "内蒙古自治区",
        "parentId": 0,
        "tagType": 1,
        "tagDescription": null,
        "deleted": null,
        "isValid": null,
        "orderSeq": null,
        "childBaseTag": [
            {
                "id": 150100,
                "tagId": 150100,
                "tagName": "呼和浩特市",
                "parentId": 150000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 150200,
                "tagId": 150200,
                "tagName": "包头市",
                "parentId": 150000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 150300,
                "tagId": 150300,
                "tagName": "乌海市",
                "parentId": 150000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 150400,
                "tagId": 150400,
                "tagName": "赤峰市",
                "parentId": 150000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 150500,
                "tagId": 150500,
                "tagName": "通辽市",
                "parentId": 150000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 150600,
                "tagId": 150600,
                "tagName": "鄂尔多斯市",
                "parentId": 150000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 150700,
                "tagId": 150700,
                "tagName": "呼伦贝尔市",
                "parentId": 150000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 150800,
                "tagId": 150800,
                "tagName": "巴彦淖尔市",
                "parentId": 150000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 150900,
                "tagId": 150900,
                "tagName": "乌兰察布市",
                "parentId": 150000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 152200,
                "tagId": 152200,
                "tagName": "兴安盟",
                "parentId": 150000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 152500,
                "tagId": 152500,
                "tagName": "锡林郭勒盟",
                "parentId": 150000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 152900,
                "tagId": 152900,
                "tagName": "阿拉善盟",
                "parentId": 150000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            }
        ]
    },
    {
        "id": 210000,
        "tagId": 210000,
        "tagName": "辽宁省",
        "parentId": 0,
        "tagType": 1,
        "tagDescription": null,
        "deleted": null,
        "isValid": null,
        "orderSeq": null,
        "childBaseTag": [
            {
                "id": 210100,
                "tagId": 210100,
                "tagName": "沈阳市",
                "parentId": 210000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 210200,
                "tagId": 210200,
                "tagName": "大连市",
                "parentId": 210000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 210300,
                "tagId": 210300,
                "tagName": "鞍山市",
                "parentId": 210000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 210400,
                "tagId": 210400,
                "tagName": "抚顺市",
                "parentId": 210000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 210500,
                "tagId": 210500,
                "tagName": "本溪市",
                "parentId": 210000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 210600,
                "tagId": 210600,
                "tagName": "丹东市",
                "parentId": 210000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 210700,
                "tagId": 210700,
                "tagName": "锦州市",
                "parentId": 210000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 210800,
                "tagId": 210800,
                "tagName": "营口市",
                "parentId": 210000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 210900,
                "tagId": 210900,
                "tagName": "阜新市",
                "parentId": 210000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 211000,
                "tagId": 211000,
                "tagName": "辽阳市",
                "parentId": 210000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 211100,
                "tagId": 211100,
                "tagName": "盘锦市",
                "parentId": 210000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 211200,
                "tagId": 211200,
                "tagName": "铁岭市",
                "parentId": 210000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 211300,
                "tagId": 211300,
                "tagName": "朝阳市",
                "parentId": 210000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 211400,
                "tagId": 211400,
                "tagName": "葫芦岛市",
                "parentId": 210000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            }
        ]
    },
    {
        "id": 220000,
        "tagId": 220000,
        "tagName": "吉林省",
        "parentId": 0,
        "tagType": 1,
        "tagDescription": null,
        "deleted": null,
        "isValid": null,
        "orderSeq": null,
        "childBaseTag": [
            {
                "id": 220100,
                "tagId": 220100,
                "tagName": "长春市",
                "parentId": 220000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 220200,
                "tagId": 220200,
                "tagName": "吉林市",
                "parentId": 220000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 220300,
                "tagId": 220300,
                "tagName": "四平市",
                "parentId": 220000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 220400,
                "tagId": 220400,
                "tagName": "辽源市",
                "parentId": 220000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 220500,
                "tagId": 220500,
                "tagName": "通化市",
                "parentId": 220000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 220600,
                "tagId": 220600,
                "tagName": "白山市",
                "parentId": 220000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 220700,
                "tagId": 220700,
                "tagName": "松原市",
                "parentId": 220000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 220800,
                "tagId": 220800,
                "tagName": "白城市",
                "parentId": 220000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 222400,
                "tagId": 222400,
                "tagName": "延边朝鲜族自治州",
                "parentId": 220000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            }
        ]
    },
    {
        "id": 230000,
        "tagId": 230000,
        "tagName": "黑龙江省",
        "parentId": 0,
        "tagType": 1,
        "tagDescription": null,
        "deleted": null,
        "isValid": null,
        "orderSeq": null,
        "childBaseTag": [
            {
                "id": 230100,
                "tagId": 230100,
                "tagName": "哈尔滨市",
                "parentId": 230000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 230200,
                "tagId": 230200,
                "tagName": "齐齐哈尔市",
                "parentId": 230000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 230300,
                "tagId": 230300,
                "tagName": "鸡西市",
                "parentId": 230000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 230400,
                "tagId": 230400,
                "tagName": "鹤岗市",
                "parentId": 230000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 230500,
                "tagId": 230500,
                "tagName": "双鸭山市",
                "parentId": 230000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 230600,
                "tagId": 230600,
                "tagName": "大庆市",
                "parentId": 230000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 230700,
                "tagId": 230700,
                "tagName": "伊春市",
                "parentId": 230000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 230800,
                "tagId": 230800,
                "tagName": "佳木斯市",
                "parentId": 230000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 230900,
                "tagId": 230900,
                "tagName": "七台河市",
                "parentId": 230000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 231000,
                "tagId": 231000,
                "tagName": "牡丹江市",
                "parentId": 230000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 231100,
                "tagId": 231100,
                "tagName": "黑河市",
                "parentId": 230000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 231200,
                "tagId": 231200,
                "tagName": "绥化市",
                "parentId": 230000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 232700,
                "tagId": 232700,
                "tagName": "大兴安岭地区",
                "parentId": 230000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            }
        ]
    },
    {
        "id": 310000,
        "tagId": 310000,
        "tagName": "上海",
        "parentId": 0,
        "tagType": 1,
        "tagDescription": null,
        "deleted": null,
        "isValid": null,
        "orderSeq": null,
        "childBaseTag": null
    },
    {
        "id": 320000,
        "tagId": 320000,
        "tagName": "江苏省",
        "parentId": 0,
        "tagType": 1,
        "tagDescription": null,
        "deleted": null,
        "isValid": null,
        "orderSeq": null,
        "childBaseTag": [
            {
                "id": 320100,
                "tagId": 320100,
                "tagName": "南京市",
                "parentId": 320000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 320200,
                "tagId": 320200,
                "tagName": "无锡市",
                "parentId": 320000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 320300,
                "tagId": 320300,
                "tagName": "徐州市",
                "parentId": 320000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 320400,
                "tagId": 320400,
                "tagName": "常州市",
                "parentId": 320000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 320500,
                "tagId": 320500,
                "tagName": "苏州市",
                "parentId": 320000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 320600,
                "tagId": 320600,
                "tagName": "南通市",
                "parentId": 320000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 320700,
                "tagId": 320700,
                "tagName": "连云港市",
                "parentId": 320000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 320800,
                "tagId": 320800,
                "tagName": "淮安市",
                "parentId": 320000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 320900,
                "tagId": 320900,
                "tagName": "盐城市",
                "parentId": 320000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 321000,
                "tagId": 321000,
                "tagName": "扬州市",
                "parentId": 320000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 321100,
                "tagId": 321100,
                "tagName": "镇江市",
                "parentId": 320000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 321200,
                "tagId": 321200,
                "tagName": "泰州市",
                "parentId": 320000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 321300,
                "tagId": 321300,
                "tagName": "宿迁市",
                "parentId": 320000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            }
        ]
    },
    {
        "id": 330000,
        "tagId": 330000,
        "tagName": "浙江省",
        "parentId": 0,
        "tagType": 1,
        "tagDescription": null,
        "deleted": null,
        "isValid": null,
        "orderSeq": null,
        "childBaseTag": [
            {
                "id": 330100,
                "tagId": 330100,
                "tagName": "杭州市",
                "parentId": 330000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 330200,
                "tagId": 330200,
                "tagName": "宁波市",
                "parentId": 330000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 330300,
                "tagId": 330300,
                "tagName": "温州市",
                "parentId": 330000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 330400,
                "tagId": 330400,
                "tagName": "嘉兴市",
                "parentId": 330000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 330500,
                "tagId": 330500,
                "tagName": "湖州市",
                "parentId": 330000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 330600,
                "tagId": 330600,
                "tagName": "绍兴市",
                "parentId": 330000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 330700,
                "tagId": 330700,
                "tagName": "金华市",
                "parentId": 330000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 330800,
                "tagId": 330800,
                "tagName": "衢州市",
                "parentId": 330000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 330900,
                "tagId": 330900,
                "tagName": "舟山市",
                "parentId": 330000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 331000,
                "tagId": 331000,
                "tagName": "台州市",
                "parentId": 330000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 331100,
                "tagId": 331100,
                "tagName": "丽水市",
                "parentId": 330000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            }
        ]
    },
    {
        "id": 340000,
        "tagId": 340000,
        "tagName": "安徽省",
        "parentId": 0,
        "tagType": 1,
        "tagDescription": null,
        "deleted": null,
        "isValid": null,
        "orderSeq": null,
        "childBaseTag": [
            {
                "id": 340100,
                "tagId": 340100,
                "tagName": "合肥市",
                "parentId": 340000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 340200,
                "tagId": 340200,
                "tagName": "芜湖市",
                "parentId": 340000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 340300,
                "tagId": 340300,
                "tagName": "蚌埠市",
                "parentId": 340000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 340400,
                "tagId": 340400,
                "tagName": "淮南市",
                "parentId": 340000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 340500,
                "tagId": 340500,
                "tagName": "马鞍山市",
                "parentId": 340000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 340600,
                "tagId": 340600,
                "tagName": "淮北市",
                "parentId": 340000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 340700,
                "tagId": 340700,
                "tagName": "铜陵市",
                "parentId": 340000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 340800,
                "tagId": 340800,
                "tagName": "安庆市",
                "parentId": 340000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 341000,
                "tagId": 341000,
                "tagName": "黄山市",
                "parentId": 340000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 341100,
                "tagId": 341100,
                "tagName": "滁州市",
                "parentId": 340000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 341200,
                "tagId": 341200,
                "tagName": "阜阳市",
                "parentId": 340000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 341300,
                "tagId": 341300,
                "tagName": "宿州市",
                "parentId": 340000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 341500,
                "tagId": 341500,
                "tagName": "六安市",
                "parentId": 340000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 341600,
                "tagId": 341600,
                "tagName": "亳州市",
                "parentId": 340000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 341700,
                "tagId": 341700,
                "tagName": "池州市",
                "parentId": 340000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 341800,
                "tagId": 341800,
                "tagName": "宣城市",
                "parentId": 340000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            }
        ]
    },
    {
        "id": 350000,
        "tagId": 350000,
        "tagName": "福建省",
        "parentId": 0,
        "tagType": 1,
        "tagDescription": null,
        "deleted": null,
        "isValid": null,
        "orderSeq": null,
        "childBaseTag": [
            {
                "id": 350100,
                "tagId": 350100,
                "tagName": "福州市",
                "parentId": 350000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 350200,
                "tagId": 350200,
                "tagName": "厦门市",
                "parentId": 350000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 350300,
                "tagId": 350300,
                "tagName": "莆田市",
                "parentId": 350000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 350400,
                "tagId": 350400,
                "tagName": "三明市",
                "parentId": 350000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 350500,
                "tagId": 350500,
                "tagName": "泉州市",
                "parentId": 350000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 350600,
                "tagId": 350600,
                "tagName": "漳州市",
                "parentId": 350000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 350700,
                "tagId": 350700,
                "tagName": "南平市",
                "parentId": 350000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 350800,
                "tagId": 350800,
                "tagName": "龙岩市",
                "parentId": 350000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 350900,
                "tagId": 350900,
                "tagName": "宁德市",
                "parentId": 350000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            }
        ]
    },
    {
        "id": 360000,
        "tagId": 360000,
        "tagName": "江西省",
        "parentId": 0,
        "tagType": 1,
        "tagDescription": null,
        "deleted": null,
        "isValid": null,
        "orderSeq": null,
        "childBaseTag": [
            {
                "id": 360100,
                "tagId": 360100,
                "tagName": "南昌市",
                "parentId": 360000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 360200,
                "tagId": 360200,
                "tagName": "景德镇市",
                "parentId": 360000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 360300,
                "tagId": 360300,
                "tagName": "萍乡市",
                "parentId": 360000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 360400,
                "tagId": 360400,
                "tagName": "九江市",
                "parentId": 360000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 360500,
                "tagId": 360500,
                "tagName": "新余市",
                "parentId": 360000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 360600,
                "tagId": 360600,
                "tagName": "鹰潭市",
                "parentId": 360000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 360700,
                "tagId": 360700,
                "tagName": "赣州市",
                "parentId": 360000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 360800,
                "tagId": 360800,
                "tagName": "吉安市",
                "parentId": 360000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 360900,
                "tagId": 360900,
                "tagName": "宜春市",
                "parentId": 360000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 361000,
                "tagId": 361000,
                "tagName": "抚州市",
                "parentId": 360000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 361100,
                "tagId": 361100,
                "tagName": "上饶市",
                "parentId": 360000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            }
        ]
    },
    {
        "id": 370000,
        "tagId": 370000,
        "tagName": "山东省",
        "parentId": 0,
        "tagType": 1,
        "tagDescription": null,
        "deleted": null,
        "isValid": null,
        "orderSeq": null,
        "childBaseTag": [
            {
                "id": 370100,
                "tagId": 370100,
                "tagName": "济南市",
                "parentId": 370000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 370200,
                "tagId": 370200,
                "tagName": "青岛市",
                "parentId": 370000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 370300,
                "tagId": 370300,
                "tagName": "淄博市",
                "parentId": 370000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 370400,
                "tagId": 370400,
                "tagName": "枣庄市",
                "parentId": 370000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 370500,
                "tagId": 370500,
                "tagName": "东营市",
                "parentId": 370000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 370600,
                "tagId": 370600,
                "tagName": "烟台市",
                "parentId": 370000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 370700,
                "tagId": 370700,
                "tagName": "潍坊市",
                "parentId": 370000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 370800,
                "tagId": 370800,
                "tagName": "济宁市",
                "parentId": 370000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 370900,
                "tagId": 370900,
                "tagName": "泰安市",
                "parentId": 370000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 371000,
                "tagId": 371000,
                "tagName": "威海市",
                "parentId": 370000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 371100,
                "tagId": 371100,
                "tagName": "日照市",
                "parentId": 370000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 371300,
                "tagId": 371300,
                "tagName": "临沂市",
                "parentId": 370000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 371400,
                "tagId": 371400,
                "tagName": "德州市",
                "parentId": 370000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 371500,
                "tagId": 371500,
                "tagName": "聊城市",
                "parentId": 370000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 371600,
                "tagId": 371600,
                "tagName": "滨州市",
                "parentId": 370000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 371700,
                "tagId": 371700,
                "tagName": "菏泽市",
                "parentId": 370000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            }
        ]
    },
    {
        "id": 410000,
        "tagId": 410000,
        "tagName": "河南省",
        "parentId": 0,
        "tagType": 1,
        "tagDescription": null,
        "deleted": null,
        "isValid": null,
        "orderSeq": null,
        "childBaseTag": [
            {
                "id": 410100,
                "tagId": 410100,
                "tagName": "郑州市",
                "parentId": 410000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 410200,
                "tagId": 410200,
                "tagName": "开封市",
                "parentId": 410000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 410300,
                "tagId": 410300,
                "tagName": "洛阳市",
                "parentId": 410000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 410400,
                "tagId": 410400,
                "tagName": "平顶山市",
                "parentId": 410000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 410500,
                "tagId": 410500,
                "tagName": "安阳市",
                "parentId": 410000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 410600,
                "tagId": 410600,
                "tagName": "鹤壁市",
                "parentId": 410000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 410700,
                "tagId": 410700,
                "tagName": "新乡市",
                "parentId": 410000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 410800,
                "tagId": 410800,
                "tagName": "焦作市",
                "parentId": 410000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 410900,
                "tagId": 410900,
                "tagName": "濮阳市",
                "parentId": 410000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 411000,
                "tagId": 411000,
                "tagName": "许昌市",
                "parentId": 410000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 411100,
                "tagId": 411100,
                "tagName": "漯河市",
                "parentId": 410000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 411200,
                "tagId": 411200,
                "tagName": "三门峡市",
                "parentId": 410000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 411300,
                "tagId": 411300,
                "tagName": "南阳市",
                "parentId": 410000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 411400,
                "tagId": 411400,
                "tagName": "商丘市",
                "parentId": 410000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 411500,
                "tagId": 411500,
                "tagName": "信阳市",
                "parentId": 410000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 411600,
                "tagId": 411600,
                "tagName": "周口市",
                "parentId": 410000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 411700,
                "tagId": 411700,
                "tagName": "驻马店市",
                "parentId": 410000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 419098,
                "tagId": 419098,
                "tagName": "济源市",
                "parentId": 410000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            }
        ]
    },
    {
        "id": 420000,
        "tagId": 420000,
        "tagName": "湖北省",
        "parentId": 0,
        "tagType": 1,
        "tagDescription": null,
        "deleted": null,
        "isValid": null,
        "orderSeq": null,
        "childBaseTag": [
            {
                "id": 420100,
                "tagId": 420100,
                "tagName": "武汉市",
                "parentId": 420000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 420200,
                "tagId": 420200,
                "tagName": "黄石市",
                "parentId": 420000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 420300,
                "tagId": 420300,
                "tagName": "十堰市",
                "parentId": 420000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 420500,
                "tagId": 420500,
                "tagName": "宜昌市",
                "parentId": 420000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 420600,
                "tagId": 420600,
                "tagName": "襄阳市",
                "parentId": 420000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 420700,
                "tagId": 420700,
                "tagName": "鄂州市",
                "parentId": 420000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 420800,
                "tagId": 420800,
                "tagName": "荆门市",
                "parentId": 420000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 420900,
                "tagId": 420900,
                "tagName": "孝感市",
                "parentId": 420000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 421000,
                "tagId": 421000,
                "tagName": "荆州市",
                "parentId": 420000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 421100,
                "tagId": 421100,
                "tagName": "黄冈市",
                "parentId": 420000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 421200,
                "tagId": 421200,
                "tagName": "咸宁市",
                "parentId": 420000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 421300,
                "tagId": 421300,
                "tagName": "随州市",
                "parentId": 420000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 422800,
                "tagId": 422800,
                "tagName": "恩施土家族苗族自治州",
                "parentId": 420000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 429078,
                "tagId": 429078,
                "tagName": "神农架林区",
                "parentId": 420000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 429093,
                "tagId": 429093,
                "tagName": "天门市",
                "parentId": 420000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 429094,
                "tagId": 429094,
                "tagName": "潜江市",
                "parentId": 420000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 429095,
                "tagId": 429095,
                "tagName": "仙桃市",
                "parentId": 420000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            }
        ]
    },
    {
        "id": 430000,
        "tagId": 430000,
        "tagName": "湖南省",
        "parentId": 0,
        "tagType": 1,
        "tagDescription": null,
        "deleted": null,
        "isValid": null,
        "orderSeq": null,
        "childBaseTag": [
            {
                "id": 430100,
                "tagId": 430100,
                "tagName": "长沙市",
                "parentId": 430000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 430200,
                "tagId": 430200,
                "tagName": "株洲市",
                "parentId": 430000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 430300,
                "tagId": 430300,
                "tagName": "湘潭市",
                "parentId": 430000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 430400,
                "tagId": 430400,
                "tagName": "衡阳市",
                "parentId": 430000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 430500,
                "tagId": 430500,
                "tagName": "邵阳市",
                "parentId": 430000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 430600,
                "tagId": 430600,
                "tagName": "岳阳市",
                "parentId": 430000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 430700,
                "tagId": 430700,
                "tagName": "常德市",
                "parentId": 430000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 430800,
                "tagId": 430800,
                "tagName": "张家界市",
                "parentId": 430000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 430900,
                "tagId": 430900,
                "tagName": "益阳市",
                "parentId": 430000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 431000,
                "tagId": 431000,
                "tagName": "郴州市",
                "parentId": 430000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 431100,
                "tagId": 431100,
                "tagName": "永州市",
                "parentId": 430000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 431200,
                "tagId": 431200,
                "tagName": "怀化市",
                "parentId": 430000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 431300,
                "tagId": 431300,
                "tagName": "娄底市",
                "parentId": 430000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 433100,
                "tagId": 433100,
                "tagName": "湘西土家族苗族自治州",
                "parentId": 430000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            }
        ]
    },
    {
        "id": 440000,
        "tagId": 440000,
        "tagName": "广东省",
        "parentId": 0,
        "tagType": 1,
        "tagDescription": null,
        "deleted": null,
        "isValid": null,
        "orderSeq": null,
        "childBaseTag": [
            {
                "id": 440100,
                "tagId": 440100,
                "tagName": "广州市",
                "parentId": 440000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 440200,
                "tagId": 440200,
                "tagName": "韶关市",
                "parentId": 440000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 440300,
                "tagId": 440300,
                "tagName": "深圳市",
                "parentId": 440000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 440400,
                "tagId": 440400,
                "tagName": "珠海市",
                "parentId": 440000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 440500,
                "tagId": 440500,
                "tagName": "汕头市",
                "parentId": 440000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 440600,
                "tagId": 440600,
                "tagName": "佛山市",
                "parentId": 440000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 440700,
                "tagId": 440700,
                "tagName": "江门市",
                "parentId": 440000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 440800,
                "tagId": 440800,
                "tagName": "湛江市",
                "parentId": 440000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 440900,
                "tagId": 440900,
                "tagName": "茂名市",
                "parentId": 440000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 441200,
                "tagId": 441200,
                "tagName": "肇庆市",
                "parentId": 440000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 441300,
                "tagId": 441300,
                "tagName": "惠州市",
                "parentId": 440000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 441400,
                "tagId": 441400,
                "tagName": "梅州市",
                "parentId": 440000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 441500,
                "tagId": 441500,
                "tagName": "汕尾市",
                "parentId": 440000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 441600,
                "tagId": 441600,
                "tagName": "河源市",
                "parentId": 440000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 441700,
                "tagId": 441700,
                "tagName": "阳江市",
                "parentId": 440000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 441800,
                "tagId": 441800,
                "tagName": "清远市",
                "parentId": 440000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 441999,
                "tagId": 441999,
                "tagName": "东莞市",
                "parentId": 440000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 442099,
                "tagId": 442099,
                "tagName": "中山市",
                "parentId": 440000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 445100,
                "tagId": 445100,
                "tagName": "潮州市",
                "parentId": 440000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 445200,
                "tagId": 445200,
                "tagName": "揭阳市",
                "parentId": 440000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 445300,
                "tagId": 445300,
                "tagName": "云浮市",
                "parentId": 440000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            }
        ]
    },
    {
        "id": 450000,
        "tagId": 450000,
        "tagName": "广西壮族自治区",
        "parentId": 0,
        "tagType": 1,
        "tagDescription": null,
        "deleted": null,
        "isValid": null,
        "orderSeq": null,
        "childBaseTag": [
            {
                "id": 450100,
                "tagId": 450100,
                "tagName": "南宁市",
                "parentId": 450000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 450200,
                "tagId": 450200,
                "tagName": "柳州市",
                "parentId": 450000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 450300,
                "tagId": 450300,
                "tagName": "桂林市",
                "parentId": 450000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 450400,
                "tagId": 450400,
                "tagName": "梧州市",
                "parentId": 450000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 450500,
                "tagId": 450500,
                "tagName": "北海市",
                "parentId": 450000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 450600,
                "tagId": 450600,
                "tagName": "防城港市",
                "parentId": 450000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 450700,
                "tagId": 450700,
                "tagName": "钦州市",
                "parentId": 450000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 450800,
                "tagId": 450800,
                "tagName": "贵港市",
                "parentId": 450000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 450900,
                "tagId": 450900,
                "tagName": "玉林市",
                "parentId": 450000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 451000,
                "tagId": 451000,
                "tagName": "百色市",
                "parentId": 450000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 451100,
                "tagId": 451100,
                "tagName": "贺州市",
                "parentId": 450000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 451200,
                "tagId": 451200,
                "tagName": "河池市",
                "parentId": 450000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 451300,
                "tagId": 451300,
                "tagName": "来宾市",
                "parentId": 450000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 451400,
                "tagId": 451400,
                "tagName": "崇左市",
                "parentId": 450000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            }
        ]
    },
    {
        "id": 460000,
        "tagId": 460000,
        "tagName": "海南省",
        "parentId": 0,
        "tagType": 1,
        "tagDescription": null,
        "deleted": null,
        "isValid": null,
        "orderSeq": null,
        "childBaseTag": [
            {
                "id": 460100,
                "tagId": 460100,
                "tagName": "海口市",
                "parentId": 460000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 460200,
                "tagId": 460200,
                "tagName": "三亚市",
                "parentId": 460000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 460399,
                "tagId": 460399,
                "tagName": "三沙市",
                "parentId": 460000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 460499,
                "tagId": 460499,
                "tagName": "儋州市",
                "parentId": 460000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 469069,
                "tagId": 469069,
                "tagName": "琼中黎族苗族自治县",
                "parentId": 460000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 469070,
                "tagId": 469070,
                "tagName": "保亭黎族苗族自治县",
                "parentId": 460000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 469071,
                "tagId": 469071,
                "tagName": "陵水黎族自治县",
                "parentId": 460000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 469072,
                "tagId": 469072,
                "tagName": "乐东黎族自治县",
                "parentId": 460000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 469073,
                "tagId": 469073,
                "tagName": "昌江黎族自治县",
                "parentId": 460000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 469074,
                "tagId": 469074,
                "tagName": "白沙黎族自治县",
                "parentId": 460000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 469075,
                "tagId": 469075,
                "tagName": "临高县",
                "parentId": 460000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 469076,
                "tagId": 469076,
                "tagName": "澄迈县",
                "parentId": 460000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 469077,
                "tagId": 469077,
                "tagName": "屯昌县",
                "parentId": 460000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 469078,
                "tagId": 469078,
                "tagName": "定安县",
                "parentId": 460000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 469092,
                "tagId": 469092,
                "tagName": "东方市",
                "parentId": 460000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 469093,
                "tagId": 469093,
                "tagName": "万宁市",
                "parentId": 460000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 469094,
                "tagId": 469094,
                "tagName": "文昌市",
                "parentId": 460000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 469097,
                "tagId": 469097,
                "tagName": "琼海市",
                "parentId": 460000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 469098,
                "tagId": 469098,
                "tagName": "五指山市",
                "parentId": 460000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            }
        ]
    },
    {
        "id": 500000,
        "tagId": 500000,
        "tagName": "重庆",
        "parentId": 0,
        "tagType": 1,
        "tagDescription": null,
        "deleted": null,
        "isValid": null,
        "orderSeq": null,
        "childBaseTag": null
    },
    {
        "id": 510000,
        "tagId": 510000,
        "tagName": "四川省",
        "parentId": 0,
        "tagType": 1,
        "tagDescription": null,
        "deleted": null,
        "isValid": null,
        "orderSeq": null,
        "childBaseTag": [
            {
                "id": 510100,
                "tagId": 510100,
                "tagName": "成都市",
                "parentId": 510000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 510300,
                "tagId": 510300,
                "tagName": "自贡市",
                "parentId": 510000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 510400,
                "tagId": 510400,
                "tagName": "攀枝花市",
                "parentId": 510000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 510500,
                "tagId": 510500,
                "tagName": "泸州市",
                "parentId": 510000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 510600,
                "tagId": 510600,
                "tagName": "德阳市",
                "parentId": 510000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 510700,
                "tagId": 510700,
                "tagName": "绵阳市",
                "parentId": 510000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 510800,
                "tagId": 510800,
                "tagName": "广元市",
                "parentId": 510000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 510900,
                "tagId": 510900,
                "tagName": "遂宁市",
                "parentId": 510000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 511000,
                "tagId": 511000,
                "tagName": "内江市",
                "parentId": 510000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 511100,
                "tagId": 511100,
                "tagName": "乐山市",
                "parentId": 510000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 511300,
                "tagId": 511300,
                "tagName": "南充市",
                "parentId": 510000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 511400,
                "tagId": 511400,
                "tagName": "眉山市",
                "parentId": 510000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 511500,
                "tagId": 511500,
                "tagName": "宜宾市",
                "parentId": 510000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 511600,
                "tagId": 511600,
                "tagName": "广安市",
                "parentId": 510000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 511700,
                "tagId": 511700,
                "tagName": "达州市",
                "parentId": 510000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 511800,
                "tagId": 511800,
                "tagName": "雅安市",
                "parentId": 510000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 511900,
                "tagId": 511900,
                "tagName": "巴中市",
                "parentId": 510000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 512000,
                "tagId": 512000,
                "tagName": "资阳市",
                "parentId": 510000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 513200,
                "tagId": 513200,
                "tagName": "阿坝藏族羌族自治州",
                "parentId": 510000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 513300,
                "tagId": 513300,
                "tagName": "甘孜藏族自治州",
                "parentId": 510000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 513400,
                "tagId": 513400,
                "tagName": "凉山彝族自治州",
                "parentId": 510000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            }
        ]
    },
    {
        "id": 520000,
        "tagId": 520000,
        "tagName": "贵州省",
        "parentId": 0,
        "tagType": 1,
        "tagDescription": null,
        "deleted": null,
        "isValid": null,
        "orderSeq": null,
        "childBaseTag": [
            {
                "id": 520100,
                "tagId": 520100,
                "tagName": "贵阳市",
                "parentId": 520000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 520200,
                "tagId": 520200,
                "tagName": "六盘水市",
                "parentId": 520000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 520300,
                "tagId": 520300,
                "tagName": "遵义市",
                "parentId": 520000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 520400,
                "tagId": 520400,
                "tagName": "安顺市",
                "parentId": 520000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 520500,
                "tagId": 520500,
                "tagName": "毕节市",
                "parentId": 520000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 520600,
                "tagId": 520600,
                "tagName": "铜仁市",
                "parentId": 520000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 522300,
                "tagId": 522300,
                "tagName": "黔西南布依族苗族自治州",
                "parentId": 520000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 522600,
                "tagId": 522600,
                "tagName": "黔东南苗族侗族自治州",
                "parentId": 520000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 522700,
                "tagId": 522700,
                "tagName": "黔南布依族苗族自治州",
                "parentId": 520000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            }
        ]
    },
    {
        "id": 530000,
        "tagId": 530000,
        "tagName": "云南省",
        "parentId": 0,
        "tagType": 1,
        "tagDescription": null,
        "deleted": null,
        "isValid": null,
        "orderSeq": null,
        "childBaseTag": [
            {
                "id": 530100,
                "tagId": 530100,
                "tagName": "昆明市",
                "parentId": 530000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 530300,
                "tagId": 530300,
                "tagName": "曲靖市",
                "parentId": 530000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 530400,
                "tagId": 530400,
                "tagName": "玉溪市",
                "parentId": 530000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 530500,
                "tagId": 530500,
                "tagName": "保山市",
                "parentId": 530000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 530600,
                "tagId": 530600,
                "tagName": "昭通市",
                "parentId": 530000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 530700,
                "tagId": 530700,
                "tagName": "丽江市",
                "parentId": 530000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 530800,
                "tagId": 530800,
                "tagName": "普洱市",
                "parentId": 530000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 530900,
                "tagId": 530900,
                "tagName": "临沧市",
                "parentId": 530000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 532300,
                "tagId": 532300,
                "tagName": "楚雄彝族自治州",
                "parentId": 530000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 532500,
                "tagId": 532500,
                "tagName": "红河哈尼族彝族自治州",
                "parentId": 530000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 532600,
                "tagId": 532600,
                "tagName": "文山壮族苗族自治州",
                "parentId": 530000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 532800,
                "tagId": 532800,
                "tagName": "西双版纳傣族自治州",
                "parentId": 530000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 532900,
                "tagId": 532900,
                "tagName": "大理白族自治州",
                "parentId": 530000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 533100,
                "tagId": 533100,
                "tagName": "德宏傣族景颇族自治州",
                "parentId": 530000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 533300,
                "tagId": 533300,
                "tagName": "怒江傈僳族自治州",
                "parentId": 530000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 533400,
                "tagId": 533400,
                "tagName": "迪庆藏族自治州",
                "parentId": 530000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            }
        ]
    },
    {
        "id": 540000,
        "tagId": 540000,
        "tagName": "西藏自治区",
        "parentId": 0,
        "tagType": 1,
        "tagDescription": null,
        "deleted": null,
        "isValid": null,
        "orderSeq": null,
        "childBaseTag": [
            {
                "id": 540100,
                "tagId": 540100,
                "tagName": "拉萨市",
                "parentId": 540000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 540200,
                "tagId": 540200,
                "tagName": "日喀则市",
                "parentId": 540000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 540300,
                "tagId": 540300,
                "tagName": "昌都市",
                "parentId": 540000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 540400,
                "tagId": 540400,
                "tagName": "林芝市",
                "parentId": 540000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 540500,
                "tagId": 540500,
                "tagName": "山南市",
                "parentId": 540000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 540600,
                "tagId": 540600,
                "tagName": "那曲市",
                "parentId": 540000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 542500,
                "tagId": 542500,
                "tagName": "阿里地区",
                "parentId": 540000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            }
        ]
    },
    {
        "id": 610000,
        "tagId": 610000,
        "tagName": "陕西省",
        "parentId": 0,
        "tagType": 1,
        "tagDescription": null,
        "deleted": null,
        "isValid": null,
        "orderSeq": null,
        "childBaseTag": [
            {
                "id": 610100,
                "tagId": 610100,
                "tagName": "西安市",
                "parentId": 610000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 610200,
                "tagId": 610200,
                "tagName": "铜川市",
                "parentId": 610000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 610300,
                "tagId": 610300,
                "tagName": "宝鸡市",
                "parentId": 610000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 610400,
                "tagId": 610400,
                "tagName": "咸阳市",
                "parentId": 610000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 610500,
                "tagId": 610500,
                "tagName": "渭南市",
                "parentId": 610000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 610600,
                "tagId": 610600,
                "tagName": "延安市",
                "parentId": 610000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 610700,
                "tagId": 610700,
                "tagName": "汉中市",
                "parentId": 610000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 610800,
                "tagId": 610800,
                "tagName": "榆林市",
                "parentId": 610000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 610900,
                "tagId": 610900,
                "tagName": "安康市",
                "parentId": 610000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 611000,
                "tagId": 611000,
                "tagName": "商洛市",
                "parentId": 610000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            }
        ]
    },
    {
        "id": 620000,
        "tagId": 620000,
        "tagName": "甘肃省",
        "parentId": 0,
        "tagType": 1,
        "tagDescription": null,
        "deleted": null,
        "isValid": null,
        "orderSeq": null,
        "childBaseTag": [
            {
                "id": 620100,
                "tagId": 620100,
                "tagName": "兰州市",
                "parentId": 620000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 620299,
                "tagId": 620299,
                "tagName": "嘉峪关市",
                "parentId": 620000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 620300,
                "tagId": 620300,
                "tagName": "金昌市",
                "parentId": 620000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 620400,
                "tagId": 620400,
                "tagName": "白银市",
                "parentId": 620000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 620500,
                "tagId": 620500,
                "tagName": "天水市",
                "parentId": 620000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 620600,
                "tagId": 620600,
                "tagName": "武威市",
                "parentId": 620000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 620700,
                "tagId": 620700,
                "tagName": "张掖市",
                "parentId": 620000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 620800,
                "tagId": 620800,
                "tagName": "平凉市",
                "parentId": 620000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 620900,
                "tagId": 620900,
                "tagName": "酒泉市",
                "parentId": 620000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 621000,
                "tagId": 621000,
                "tagName": "庆阳市",
                "parentId": 620000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 621100,
                "tagId": 621100,
                "tagName": "定西市",
                "parentId": 620000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 621200,
                "tagId": 621200,
                "tagName": "陇南市",
                "parentId": 620000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 622900,
                "tagId": 622900,
                "tagName": "临夏回族自治州",
                "parentId": 620000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 623000,
                "tagId": 623000,
                "tagName": "甘南藏族自治州",
                "parentId": 620000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            }
        ]
    },
    {
        "id": 630000,
        "tagId": 630000,
        "tagName": "青海省",
        "parentId": 0,
        "tagType": 1,
        "tagDescription": null,
        "deleted": null,
        "isValid": null,
        "orderSeq": null,
        "childBaseTag": [
            {
                "id": 630100,
                "tagId": 630100,
                "tagName": "西宁市",
                "parentId": 630000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 630200,
                "tagId": 630200,
                "tagName": "海东市",
                "parentId": 630000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 632200,
                "tagId": 632200,
                "tagName": "海北藏族自治州",
                "parentId": 630000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 632300,
                "tagId": 632300,
                "tagName": "黄南藏族自治州",
                "parentId": 630000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 632500,
                "tagId": 632500,
                "tagName": "海南藏族自治州",
                "parentId": 630000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 632600,
                "tagId": 632600,
                "tagName": "果洛藏族自治州",
                "parentId": 630000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 632700,
                "tagId": 632700,
                "tagName": "玉树藏族自治州",
                "parentId": 630000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 632800,
                "tagId": 632800,
                "tagName": "海西蒙古族藏族自治州",
                "parentId": 630000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            }
        ]
    },
    {
        "id": 640000,
        "tagId": 640000,
        "tagName": "宁夏回族自治区",
        "parentId": 0,
        "tagType": 1,
        "tagDescription": null,
        "deleted": null,
        "isValid": null,
        "orderSeq": null,
        "childBaseTag": [
            {
                "id": 640100,
                "tagId": 640100,
                "tagName": "银川市",
                "parentId": 640000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 640200,
                "tagId": 640200,
                "tagName": "石嘴山市",
                "parentId": 640000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 640300,
                "tagId": 640300,
                "tagName": "吴忠市",
                "parentId": 640000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 640400,
                "tagId": 640400,
                "tagName": "固原市",
                "parentId": 640000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 640500,
                "tagId": 640500,
                "tagName": "中卫市",
                "parentId": 640000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            }
        ]
    },
    {
        "id": 650000,
        "tagId": 650000,
        "tagName": "新疆维吾尔自治区",
        "parentId": 0,
        "tagType": 1,
        "tagDescription": null,
        "deleted": null,
        "isValid": null,
        "orderSeq": null,
        "childBaseTag": [
            {
                "id": 650100,
                "tagId": 650100,
                "tagName": "乌鲁木齐市",
                "parentId": 650000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 650200,
                "tagId": 650200,
                "tagName": "克拉玛依市",
                "parentId": 650000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 650400,
                "tagId": 650400,
                "tagName": "吐鲁番市",
                "parentId": 650000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 650500,
                "tagId": 650500,
                "tagName": "哈密市",
                "parentId": 650000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 652300,
                "tagId": 652300,
                "tagName": "昌吉回族自治州",
                "parentId": 650000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 652700,
                "tagId": 652700,
                "tagName": "博尔塔拉蒙古自治州",
                "parentId": 650000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 652800,
                "tagId": 652800,
                "tagName": "巴音郭楞蒙古自治州",
                "parentId": 650000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 652900,
                "tagId": 652900,
                "tagName": "阿克苏地区",
                "parentId": 650000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 653000,
                "tagId": 653000,
                "tagName": "克孜勒苏柯尔克孜自治州",
                "parentId": 650000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 653100,
                "tagId": 653100,
                "tagName": "喀什地区",
                "parentId": 650000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 653200,
                "tagId": 653200,
                "tagName": "和田地区",
                "parentId": 650000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 654000,
                "tagId": 654000,
                "tagName": "伊犁哈萨克自治州",
                "parentId": 650000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 654200,
                "tagId": 654200,
                "tagName": "塔城地区",
                "parentId": 650000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 654300,
                "tagId": 654300,
                "tagName": "阿勒泰地区",
                "parentId": 650000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 659089,
                "tagId": 659089,
                "tagName": "胡杨河市",
                "parentId": 650000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 659090,
                "tagId": 659090,
                "tagName": "昆玉市",
                "parentId": 650000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 659091,
                "tagId": 659091,
                "tagName": "可克达拉市",
                "parentId": 650000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 659092,
                "tagId": 659092,
                "tagName": "双河市",
                "parentId": 650000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 659093,
                "tagId": 659093,
                "tagName": "铁门关市",
                "parentId": 650000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 659094,
                "tagId": 659094,
                "tagName": "北屯市",
                "parentId": 650000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 659095,
                "tagId": 659095,
                "tagName": "五家渠市",
                "parentId": 650000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 659096,
                "tagId": 659096,
                "tagName": "图木舒克市",
                "parentId": 650000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 659097,
                "tagId": 659097,
                "tagName": "阿拉尔市",
                "parentId": 650000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            },
            {
                "id": 659098,
                "tagId": 659098,
                "tagName": "石河子市",
                "parentId": 650000,
                "tagType": 1,
                "tagDescription": null,
                "deleted": null,
                "isValid": null,
                "orderSeq": null,
                "childBaseTag": null
            }
        ]
    },
    {
        "id": 710199,
        "tagId": 710199,
        "tagName": "台湾省",
        "parentId": 0,
        "tagType": 1,
        "tagDescription": null,
        "deleted": null,
        "isValid": null,
        "orderSeq": null,
        "childBaseTag": null
    },
    {
        "id": 810000,
        "tagId": 810000,
        "tagName": "香港特别行政区",
        "parentId": 0,
        "tagType": 1,
        "tagDescription": null,
        "deleted": null,
        "isValid": null,
        "orderSeq": null,
        "childBaseTag": null
    },
    {
        "id": 820000,
        "tagId": 820000,
        "tagName": "澳门特别行政区",
        "parentId": 0,
        "tagType": 1,
        "tagDescription": null,
        "deleted": null,
        "isValid": null,
        "orderSeq": null,
        "childBaseTag": null
    }
]


// WEBPACK FOOTER //
// ./src/components/vivo/vivopda/region.js